<div class="dialog__container">
  <div class="dialog__header">
    <span>{{ title }}</span>
  </div>
  <div class="dialog__content">
    <div class="dialog__label" *ngIf="message">
      <span>{{ message }}</span>
    </div>
    <ng-container [formGroup]="confirmForm">
      <div class="dialog__input-container" *ngIf="dropdownOptions.length">
        <app-dropdown
          [options]="dropdownOptions"
          [placeholder]="dropdownPlaceholder"
          formControlName="dropdown">
        </app-dropdown>
      </div>
      <div class="dialog__input-container" *ngIf="showInput">
        <app-form-input
          [placeholder]="inputPlaceholder"
          [type]="inputType"
          formControlName="input"
          (valueChange)="onInputChange($event)">
        </app-form-input>
      </div>
    </ng-container>
  </div>
  <div class="dialog__footer">
    <div class="dialog__button-container">
      <app-action-button
        [buttonSize]="ActionButtonSize.Small"
        [buttonType]="ActionButtonType.Cancel"
        (clicked)="onCancel()">
        {{ 'webPos.Cancel' | translate }}
      </app-action-button>
    </div>
    <div class="dialog__button-container">
      <span class="validation-tooltip validation-tooltip--full-width"
        [class.validation-tooltip--disabled]="showInputInvalidTooltip"
        [attr.tabindex]="showInputInvalidTooltip ? 0 : null"
        [attr.aria-describedby]="showInputInvalidTooltip ? inputTooltipId : null">
        <app-action-button
          [buttonSize]="ActionButtonSize.Small"
          [buttonType]="ActionButtonType.Confirm"
          [disabled]="confirmForm.invalid && showInput"
          (clicked)="onConfirm()">
          {{ confirmButtonText }}
        </app-action-button>
        @if (showInputInvalidTooltip) {
          <span class="validation-tooltip__text" [id]="inputTooltipId" role="tooltip">{{ inputInvalidTooltip }}</span>
        }
      </span>
    </div>
  </div>
</div>
